import React from 'react';

import { getAdvancedSettings } from '../advancedSettings';
import { getBackgroundSettings } from '../backgroundSettings';
import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';

import classes from './PageBuilderTabItem.module.scss';
import type { TabItemType } from './tabItemConfigAggregator';

type PageBuilderTabItemProps = TabItemType;

/**
 * Return the PB TabItem
 * @param props
 * @constructor
 */
export function PageBuilderTabItem(props: PageBuilderTabItemProps) {
    /**
     * Configure the styles requires for the Block
     */
    const backgroundStyles = getBackgroundSettings<PageBuilderTabItemProps>({ ...props });
    const advancedSettings = getAdvancedSettings<PageBuilderTabItemProps>(props);

    const layoutStyles = {
        minHeight: props.minHeight,
    };

    if (props.verticalAlignment) {
        layoutStyles['flexDirection'] = 'column';
        layoutStyles['justifyContent'] = props.verticalAlignment;
    }

    const tabItemClassNames = [classes['root'], 'pageBuilderTabItemGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        tabItemClassNames.push(...props.cssClasses);
    }

    const backgroundImageStyles = `
        #${props.uniqueID} {
            background-image: url(${props.mobileImage ?? props.desktopImage})
        }
    
        @media (min-width: 900px) {
            #${props.uniqueID} {
                background-image: url(${props.desktopImage})
            }
        }
    `;

    /**
     * Render the TabItem UI
     */
    return (
        <>
            {props.desktopImage && <style dangerouslySetInnerHTML={{ __html: backgroundImageStyles }} />}
            <PageBuilderElementWrapper
                contentType={props.contentType}
                uniqueID={props.uniqueID}
                styles={{
                    ...advancedSettings,
                    ...backgroundStyles,
                    ...layoutStyles,
                }}
                classNames={tabItemClassNames}
            >
                {props.children}
            </PageBuilderElementWrapper>
        </>
    );
}
